import React, { useState, useEffect} from 'react';
import axios from 'axios';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
//let fetchedMail = false;

function ModalSupportMailAutoBooking(props) {
     const { booking_id, branchID } = props;

    const [selectLanguage, setSelectLanguage] = useState('En');
    const [htmlMaiil, setHtmlMail] = useState({
        htmlMailBookingEn: "",
        htmlMailBookingJa: "",
        htmlMailBookingVi: "",
    });

     const [pdfUrl, setPdfUrl] = useState(``);
    //`https://database.azumayareport.com/booking_file/AZTEST/${booking_id}.pdf`
    
    // Dummy booking confirmation data

    const modules = {
        toolbar: [
            [{ 'color': [] }],     // 🔥 màu chữ
            [{ 'background': [] }],// 🔥 màu nền
            ['bold', 'italic', 'underline'],
            [{ 'header': [1, 2, 3, false] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ]
    };

    useEffect(() => {
        // if (fetchedMail) return;
        // fetchedMail = true;

        const load = async () => {
            const res = await axios.get(`/booking/${branchID}/take_mail_format_auto_booking/${booking_id}`);
            // FIX: set đúng key
            setHtmlMail({
                htmlMailBookingEn: res.data.data.htmlMailBookingEn || "",
                htmlMailBookingJa: res.data.data.htmlMailBookingJa || "",
                htmlMailBookingVi: res.data.data.htmlMailBookingVi || "",
            });

            setPdfUrl(`https://database.azumayareport.com/booking_file/${res.data.data.link.slice(19,100).replace(/\\/g, '/')}`);
        };

        load();
    }, [booking_id, branchID]);

    // PDF link state

    return (
        <div style={{  width: '100%', height: '90vh', gap: 24 }}>
            {/* Left: Email Template Editor */}
            <div className='d-flex'>
                <div style={{ flex: 1, padding: 16, borderRight: '1px solid #eee', background: '#fafbfc', }}>
                    <h3>Email Template</h3>
                    
                    <div className='main-content-lang' style={{marginTop:"0"}} >
                        <div className="radio">
                            <label className="language" onClick={() => setSelectLanguage("En")}>
                                <input type="radio" name="language" className=""
                                    checked={selectLanguage === "En"}
                                    onClick={() => setSelectLanguage("En")}
                                    id="english" ng-click="translate('en')"  />
                                <strong> English </strong>
                            </label>

                            <label className="language ml-3" onClick={() => setSelectLanguage("Ja")}>
                                <input type="radio" name="language" className=""
                                    checked={selectLanguage === "Ja"}
                                    onClick={() => setSelectLanguage("Ja")}
                                    ng-click="translate('jp')" id="japanese" />
                                <strong> Japanese </strong>
                            </label>
                            <label className="language ml-3" onClick={() => setSelectLanguage("Vi")}>
                                <input type="radio" name="language" className=""
                                    checked={selectLanguage === "Vi"}
                                    onClick={() => setSelectLanguage("Vi")}
                                    ng-click="translate('vn')" id="vietnamese" />
                                <strong> Vietnamese </strong>
                            </label>  
                        </div>
                    </div>


                    <ReactQuill
                        value={selectLanguage === "En" ? htmlMaiil["htmlMailBookingEn"] : selectLanguage === "Ja" ? htmlMaiil["htmlMailBookingJa"] : htmlMaiil["htmlMailBookingVi"]}
                        onChange={(v) => {
                            setHtmlMail(prev => ({
                                ...prev,
                                ["htmlMailBooking" + selectLanguage]: v
                            }));
                        }}
                        modules={modules}
                        theme="snow"
                        style={{ height: "500px", marginTop: "20px" }}
                    />

                    {/* <div style={{ marginTop: "40px", border: "1px solid gray", padding: 10 }}>
                        <div dangerouslySetInnerHTML={{ __html: htmlMaiil["htmlMailBooking" + selectLanguage] }} />
                    </div> */}
                    

                    {/* <div dangerouslySetInnerHTML={{ __html: htmlMaiil["htmlMailBooking" + selectLanguage] }} style={{border:'1px solid black', marginTop:"32px"}}/> */}
                    {/* <div
                        contentEditable
                        suppressContentEditableWarning={true}
                        style={{ border: '1px solid black', marginTop: '32px', minHeight: 200, padding: 8 }}
                        onInput={e => {
                            const updatedHtml = e.currentTarget.innerHTML;
                            setHtmlMail(prev => ({
                                ...prev,
                                ["htmlMailBooking" + selectLanguage]: updatedHtml
                            }));
                        }}
                        dangerouslySetInnerHTML={{ __html: htmlMaiil["htmlMailBooking" + selectLanguage] || '' }}
                    /> */}
                    {/* <textarea
                        style={{ width: '100%', height: '70%', fontSize: 16, padding: 8 }}
                        value={emailTemplate}
                        onChange={e => setEmailTemplate(e.target.value)}
                        placeholder="Write your email template here..."
                    /> */}
                </div>
                {/* Right: Booking Confirmation Display */}
                <div style={{ flex: 1,  }}>
                    <h3>Booking Confirmation</h3>
                    <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                        <input
                            id="pdfUrl"
                            type="text"
                            value={pdfUrl}
                            onChange={e => setPdfUrl(e.target.value)}
                            style={{ flex: 1, padding: 6, fontSize: 14 }}
                            placeholder="Enter PDF URL..."
                        />
                        <button
                            type="button"
                            className='btn btn-primary'
                            style={{ padding: '6px 16px', fontSize: 14, cursor: 'pointer' }}
                            onClick={() => window.open(pdfUrl, '_blank')}
                        >
                            Open PDF
                        </button>
                    </div>
                    <div style={{ height: '600px', border: '1px solid #ccc', borderRadius: 4, overflow: 'hidden', background: '#fff' }}>
                        <iframe
                            src={pdfUrl}
                            title="Booking Confirmation PDF"
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            allow="autoplay"
                        />
                    </div>
                </div>
            </div>
            <div className='mt-3'>
                <button
                    type="button"
                    style={{ fontSize: `14px`}}
                    onClick={() => props.featureButton1(htmlMaiil)}
                    className='btn btn-primary'>Save Edit</button>

                {branchID === 99 &&<button
                    type="button"
                    style={{ fontSize: `14px`}}
                    onClick={() => props.featureButton2({
                        ...htmlMaiil,
                        booking_id,
                        branchID
                    })}
                    className='btn btn-success ml-2'>Send Email</button>}

                <button
                    type="button"
                    style={{ fontSize: `14px`}}
                    onClick={() => props.featureButton3()}
                    className='btn btn-danger ml-2'>Cancel</button>
            </div>
        </div>


    );
}
export default ModalSupportMailAutoBooking;